import { Button, Space, Switch, Table } from "antd";
import { useTranslation } from "react-i18next";

import type { ColumnsType } from "antd/es/table";
import { IClinic, IOrderItem, IProduct } from "@interfaces";
import { useNotify } from "@utils";

import { memo } from "react";
import { useDispatch } from "react-redux";
import { setLoading } from "@redux";
import { clinicApi } from "@api";
import { Link } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";
import { PATH_PRODUCT_CREATE } from "@configs";

interface IProps {
  data: IOrderItem[];
  callback: () => void;
}
export const OrderTable = memo(({ data, callback }: IProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { success, error } = useNotify();

  const dataSource: IOrderItem[] = data;

  const columns: ColumnsType<IOrderItem> = [
    {
      title: t("page.oirder_ID"),
      dataIndex: "",
      key: "1",
    },
    {
      title: t("page.order_date"),
      dataIndex: "",
      key: "2",
    },
    {
      title: t("page.payment_status"),
      dataIndex: "",
      key: "3",
    },
    {
      title: t("page.order_status"),
      dataIndex: "",
      key: "4",
    },
    {
      title: t("page.order_cancel"),
      dataIndex: "",
      key: "5",
    },
    {
      title: t("page.order_type"),
      dataIndex: "",
      key: "5",
    },
    {
      title: t("page.total_amount"),
      dataIndex: "",
      key: "5",
    },
    {
      title: t("page.actions"),
      key: "9",
      render: (_, record) => (
        <Space size="middle">
          <Switch onChange={(value: boolean) => onChange(value, record)} />
          <Space>
            <Link to={PATH_PRODUCT_CREATE + `/${record.id}`}>
              <Button type="ghost" icon={<EditOutlined />} size={"small"} />
              <span>{t("page.edit")}</span>
            </Link>
          </Space>
        </Space>
      ),
    },
  ];

  const onChange = async (value: boolean, record: IOrderItem) => {
    try {
      dispatch(setLoading(true));
      await console.log("call update api");
      callback();
      success(t("message.update.success"));
    } catch (err: any) {
      error(t("message.update.fail"));
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return <Table dataSource={dataSource} rowKey={"userId"} columns={columns} pagination={false} />;
});
